import { SelectInput, required } from "react-admin";
import { NationalityType } from "utils/choices";
import GridItem from "./GridItem";

const NationalityInput = ({ source = "nationality", md = 6, isRequired = false }) => (
  <GridItem md={md}>
    <SelectInput
      source={source}
      label="Националност"
      choices={NationalityType}
      fullWidth
      validate={isRequired ? required("Полето е задължително.") : undefined}
    />
  </GridItem>
);

export default NationalityInput;
